import { AUDIT_INVALID_FIELD_TAB_BY_FIELD, AuditInvalidFieldTabKey } from 'src/app/constants/audit-invalid-field-tab.constants';

export function resolveAuditInvalidFieldTabIndex(fieldName: string, isDraft: boolean): number {
  const tabKey = AUDIT_INVALID_FIELD_TAB_BY_FIELD[fieldName] ?? 'basics';
  const baseIndex = isDraft ? 0 : 1;

  switch (tabKey as AuditInvalidFieldTabKey) {
    case 'responsibles':
      return baseIndex + 1;
    case 'files':
      return baseIndex + 2;
    case 'basics':
    default:
      return baseIndex;
  }
}
